import axios from 'axios';
import config from '../config';
import {
    OnboardDeviceHardwareConfiguration,
    OnboardDeviceHardwareConfigurationRequestBody,
} from '../interfaces';

export const postOnboardDevicesHardwareConfiguration = (
    request: OnboardDeviceHardwareConfigurationRequestBody,
): Promise<OnboardDeviceHardwareConfiguration> => {
    return axios
        .post(`${config.API_URL}/onboard-devices/hardware-configurations`, request)
        .then((response: any) => {
            return response.data;
        });
};
